import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import ProductImage from "../../../Common/ProductImage";
import GroupHeader from "./GroupHeader";
import ProductList from "./ProductList";

const useStyles = makeStyles((theme) => ({
  productGroupCard: {
    flex: 1,
    backgroundColor: "#fff",
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    overflow: "hidden",
  },
  productImageContainer: {
    // width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    padding: theme.spacing(2),
    overflow: "hidden",
    boxSizing: "border-box",
    "& img": {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "auto",
      height: "auto",
      objectFit: "contain",
    },
  },
}));

export default function ProductGroupCard({
  groupId,
  groupTitle,
  groupData,
  isLoading = false,
}) {
  const classes = useStyles();


  const getAllProducts = (group) => {
    const products = [];
    if (group?.matches) {
      products.push(...group.matches);
    }
    if (group?.original) {
      products.push(group.original);
    }
    return products;
  };

  const products = groupData ? getAllProducts(groupData) : [];
  const productCount = products.length;

  return (
    <Card className={classes.productGroupCard}>
      <div className={classes.productImageContainer}>
  
          <ProductImage
            product_matching_group_id={groupId}
            hide_multiple_icon={false}
            style={{ maxWidth: "100%", maxHeight: "200px", width: "auto", height: "auto", objectFit: "contain" }}
          />
  
      </div>
      <GroupHeader
        groupId={groupId}
        groupTitle={groupTitle}
        productCount={productCount}
      />
      <ProductList products={products} isLoading={isLoading} />
    </Card>
  );
}
